"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawData = void 0;
var react_1 = require("react");
var actions_1 = require("../../../redux/reducers/draws/actions");
var useDrawData = function (drawId, promotionId) {
    var _a = (0, react_1.useState)([]), drawPrizes = _a[0], setDrawPrizes = _a[1];
    var _b = (0, react_1.useState)([]), draws = _b[0], setDraws = _b[1];
    var _c = (0, react_1.useState)(), draw = _c[0], setDraw = _c[1];
    var _d = (0, react_1.useState)([]), drawPrizesWithContent = _d[0], setDrawPrizesWithContent = _d[1];
    var _e = (0, react_1.useState)([]), drawPrizesWithWinners = _e[0], setDrawPrizesWithWinners = _e[1];
    var _f = (0, react_1.useState)(), latestDrawHistory = _f[0], setLatestDrawHistory = _f[1];
    var _g = (0, react_1.useState)(false), drawHistoryRetrieved = _g[0], setDrawHistoryRetrieved = _g[1];
    var _h = (0, react_1.useState)(0), drawEntries = _h[0], setDrawEntries = _h[1];
    var initData = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedDrawPrizes, fetchedDraw, fetchedDrawPrizesWithContent, fetchedDrawPrizesWithWinners, fetchedLatestDrawHistory;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(drawId !== undefined)) return [3, 6];
                    return [4, (0, actions_1.fetchDrawPrizesById)(drawId)];
                case 1:
                    fetchedDrawPrizes = _a.sent();
                    return [4, (0, actions_1.getDrawWithAdditionalInformation)(drawId)];
                case 2:
                    fetchedDraw = _a.sent();
                    return [4, (0, actions_1.getDrawPrizesWithContent)(drawId)];
                case 3:
                    fetchedDrawPrizesWithContent = _a.sent();
                    return [4, (0, actions_1.getDrawPrizesWithWinners)(drawId)];
                case 4:
                    fetchedDrawPrizesWithWinners = _a.sent();
                    return [4, (0, actions_1.getLatestDrawHistory)(drawId)];
                case 5:
                    fetchedLatestDrawHistory = _a.sent();
                    setDrawPrizes(fetchedDrawPrizes !== null && fetchedDrawPrizes !== void 0 ? fetchedDrawPrizes : []);
                    setDraw(fetchedDraw);
                    setDrawPrizesWithContent(fetchedDrawPrizesWithContent !== null && fetchedDrawPrizesWithContent !== void 0 ? fetchedDrawPrizesWithContent : []);
                    setDrawPrizesWithWinners(fetchedDrawPrizesWithWinners !== null && fetchedDrawPrizesWithWinners !== void 0 ? fetchedDrawPrizesWithWinners : []);
                    setLatestDrawHistory(fetchedLatestDrawHistory);
                    setDrawHistoryRetrieved(true);
                    _a.label = 6;
                case 6: return [2];
            }
        });
    }); }, [drawId]);
    var fetchDraws = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedDraws;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(promotionId !== undefined)) return [3, 2];
                    return [4, (0, actions_1.getDrawsByPromotion)(promotionId)];
                case 1:
                    fetchedDraws = _a.sent();
                    setDraws(fetchedDraws !== null && fetchedDraws !== void 0 ? fetchedDraws : []);
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); }, [promotionId]);
    var fetchDrawEntries = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedEntries;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(promotionId !== undefined && drawId !== undefined)) return [3, 2];
                    return [4, (0, actions_1.getDrawEntries)(promotionId, drawId)];
                case 1:
                    fetchedEntries = _a.sent();
                    setDrawEntries(fetchedEntries !== null && fetchedEntries !== void 0 ? fetchedEntries : 0);
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); }, [promotionId, drawId]);
    (0, react_1.useEffect)(function () {
        initData();
    }, [initData]);
    (0, react_1.useEffect)(function () {
        fetchDraws();
    }, [fetchDraws]);
    (0, react_1.useEffect)(function () {
        fetchDrawEntries();
    }, [fetchDrawEntries]);
    return { drawPrizes: drawPrizes, draws: draws, draw: draw, drawPrizesWithContent: drawPrizesWithContent, drawPrizesWithWinners: drawPrizesWithWinners, drawHistoryRetrieved: drawHistoryRetrieved, latestDrawHistory: latestDrawHistory, drawEntries: drawEntries };
};
exports.useDrawData = useDrawData;
//# sourceMappingURL=useDrawData.js.map